import { useEffect, useState } from 'react';

export default function useSlideCenterPadding() {
  const [centerPadding, setCenterPadding] = useState(0);

  useEffect(() => {
    let rafId = 0;

    function updateCenterPadding() {
      const maxWidth = Math.min(window.innerWidth, 1800);
      const fallbackImageWidth = 1056;

      const [, imageWidth] = new Array<[number, number]>(
        [768, 297],
        [1024, 582],
        [1280, 797],
        [1440, 996],
        [Infinity, fallbackImageWidth]
      ).find(([docWidth]) => maxWidth < docWidth) ?? [
        Infinity,
        fallbackImageWidth
      ];

      setCenterPadding((maxWidth - imageWidth) / 2);
    }

    function handleOrientationChange() {
      window.setTimeout(updateCenterPadding, 500);
    }

    function handleResize() {
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(updateCenterPadding);
    }

    updateCenterPadding();

    window.addEventListener('orientationchange', handleOrientationChange);
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('orientationchange', handleOrientationChange);
      window.removeEventListener('resize', handleResize);

      if (rafId) cancelAnimationFrame(rafId);
    };
  }, []);

  return centerPadding;
}
